import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { usePoll, PageHeader, Empty, Pill } from "@/components/common";
import { ServerForm } from "@/components/ServerForm";
import { Button } from "@/components/ui/button";

export default function Servers() {
  const { data, reload } = usePoll("/admin/servers", 5000);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <div>
      <PageHeader title="Authorized servers" sub="Downstream servers identified by IP. Deny by default — only whitelisted IPs get the channels granted to them."
        right={<Button data-testid="new-server-btn" onClick={() => setOpen(true)} className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold"><Plus size={15} /> Authorize server</Button>} />
      {data && data.length === 0 ? <Empty>No authorized servers. Every stream request is currently refused (403).</Empty> : (
        <div className="bg-[#0F1722] border border-slate-800 rounded-md overflow-hidden">
          <table className="w-full" data-testid="servers-table">
            <thead><tr className="border-b border-slate-800 text-left text-[10px] uppercase tracking-wider text-slate-500">
              {["Server", "IPs / ranges", "Grants", "State", "Connections", "Bandwidth"].map((h) => <th key={h} className="px-4 py-2 font-semibold">{h}</th>)}
            </tr></thead>
            <tbody>
              {(data || []).map((s) => (
                <tr key={s.id} data-testid={`server-row-${s.id}`} onClick={() => nav(`/servers/${s.id}`)} className="border-b border-slate-800/70 hover:bg-slate-800/30 cursor-pointer transition-colors">
                  <td className="px-4 py-2.5"><div className="text-sm text-slate-100 font-medium">{s.name}</div><div className="text-[11px] text-slate-500">{s.notes}</div></td>
                  <td className="px-4 py-2.5 font-mono text-xs text-slate-300">{s.ips.join(", ") || "—"}</td>
                  <td className="px-4 py-2.5 font-mono text-xs text-slate-300">{s.all_channels ? <Pill tone="cyan">all channels</Pill> : `${s.channels.length} channel(s)`}</td>
                  <td className="px-4 py-2.5">{s.enabled ? <Pill tone="green">enabled</Pill> : <Pill tone="red">disabled</Pill>}</td>
                  <td data-testid={`server-conns-${s.id}`} className="px-4 py-2.5 font-mono text-xs text-slate-300">{s.usage?.connections ?? 0}<span className="text-slate-500"> / {s.max_connections || "∞"}</span></td>
                  <td data-testid={`server-mbps-${s.id}`} className="px-4 py-2.5 font-mono text-xs text-slate-300">{(s.usage?.mbps ?? 0).toFixed(2)}<span className="text-slate-500"> / {s.max_mbps || "∞"} Mb/s</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <ServerForm open={open} onOpenChange={setOpen} onSaved={(d) => { reload(); nav(`/servers/${d.id}`); }} />
    </div>
  );
}
